




















import { VueCustom, CustomVueConstructor } from 'vue-custom';
import { isSafari, isIOS, isElementChildOf } from 'utils';
import { mapGetters } from 'stores';

import { A, Z, ESC } from 'constants/keys';
import { ANIMATION_GAME_COMPLETION } from 'constants/animations';
import { SEARCH_BAR_ID } from 'constants/ui';

import EventsManager from 'managers/events.manager';
import ScrollManager from 'managers/scroll.manager';

import IconSearch from 'assets/icons/search.svg';
import IconClose from 'assets/icons/close.svg';

type ComponentCustom = {
  $refs: {
    input: HTMLInputElement,
    container: HTMLDivElement,
  },
};
export default (VueCustom as CustomVueConstructor<ComponentCustom>).extend({
  name: 'search-bar',
  components: {
    IconSearch,
    IconClose,
  },
  computed: {
    ...mapGetters({
      isActive: 'isSearchActive',
      query: 'searchQuery',
      isPopupActive: 'isPopupActive',
      isTutorialFinished: 'areTutorialsFinished',
      isAnimationActive: 'isAnimationActive',
      isArtModeEnabled: 'isArtModeEnabled',
    }),
    tabIndex(): number {
      return this.isPopupActive ? -1 : 0;
    },
    classes(): Record<string, boolean> {
      return {
        'js-hidden': !this.isActive,
        'js-visible': this.isActive,
      };
    },
    iconClasses(): Record<string, boolean> {
      return {
        'js-hidden': !this.isTutorialFinished,
      };
    },
    isCompletionAnimationActive(): boolean {
      return this.isAnimationActive(ANIMATION_GAME_COMPLETION);
    },
    SEARCH_BAR_ID(): string {
      return SEARCH_BAR_ID;
    },
  },
  mounted() {
    this.blurHackForIOS = this.blurHackForIOS.bind(this);

    this.initListener();
  },
  watch: {
    isCompletionAnimationActive(active) {
      if (!active) return;

      this.hide();
    },
    isActive(active) {
      if (active) return;

      this.onHide();
    },
  },
  methods: {
    initListener() {
      EventsManager.on('KEY_DOWN', (event) => {
        if (this.isActive || this.isPopupActive) return;

        const focusedElement = document.activeElement;
        if (focusedElement && (focusedElement !== document.body && focusedElement.tagName !== 'INPUT')) return;
        if (event.keyCode < A || event.keyCode > Z) return;
        if (event.ctrlKey || event.metaKey) return;

        this.show();
      });
    },
    getValue() {
      return this.$refs.input.value;
    },
    onKeyUp(e: KeyboardEvent) {
      const value = this.getValue();
      if (this.isActive && e.keyCode === ESC) {
        e.preventDefault();
        this.hide();

        return;
      }

      if (this.query === value) return;

      this.$store.dispatch('search', value);
    },

    toggle() {
      if (this.isActive) {
        this.hide();
      } else {
        this.show(true);
      }
    },
    show(playSound = false) {
      const canShow = this.isTutorialFinished && !this.isCompletionAnimationActive;
      if (!canShow) return;

      this.$store.dispatch('searchShow');
      this.$refs.input.focus();

      ScrollManager.savePosition();

      if (playSound) {
        this.emitSound();
      }

      if (isSafari() && isIOS()) {
        document.addEventListener('touchstart', this.blurHackForIOS);
      }
    },
    emitSound() {
      EventsManager.emit('BUTTON_CLICK');
    },

    hide() {
      window.setTimeout(() => this.$store.dispatch('searchHide'), 50);
    },
    onHide() {
      this.$refs.input.blur();
      this.$refs.input.value = '';

      ScrollManager.applyPosition();

      if (isSafari() && isIOS()) {
        document.removeEventListener('touchstart', this.blurHackForIOS);
      }
    },

    blurHackForIOS(e: Event) {
      if (!e.target) return;

      if (!isElementChildOf(this.$refs.container, e.target as HTMLElement)) {
        if (this.isArtModeEnabled) {
          window.setTimeout(() => this.$refs.input.blur(), 100);
        } else {
          this.$refs.input.blur();
        }
      }
    },
  },
});
